import { render, staticRenderFns } from "./menu-tag-legend.vue?vue&type=template&id=45cf291a&scoped=true"
import script from "./menu-tag-legend.vue?vue&type=script&lang=ts"
export * from "./menu-tag-legend.vue?vue&type=script&lang=ts"
import style0 from "./menu-tag-legend.vue?vue&type=style&index=0&id=45cf291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf291a",
  null
  
)

export default component.exports